// externals
import type { Reducer } from 'redux';

// libraries
import type { DeskingGlobalState } from '@makemydeal/dr-dash-types';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

import {
    FEES_ACCORDION_TOGGLE,
    LIENHOLDER_ACCORDION_TOGGLE,
    PAYMENT_DETAILS_ACCORDION_TOGGLE,
    TAXES_ACCORDION_TOGGLE,
    OPEN_PROGRAMS_SLIDEOUT,
    CLOSE_PROGRAMS_SLIDEOUT,
    SET_PROGRAMS_CALC_ENDPOINT_STASH,
    DEAL_TYPE_OVERRIDDEN,
    DISMISS_DEAL_TYPE_OVERRIDE
} from '../actionTypes/deskingGlobalActionTypes';
import { OPEN_ACCESSORIES_CATALOG_SLIDEOUT, CLOSE_ACCESSORIES_CATALOG_SLIDEOUT } from '../actionTypes/accessoriesActionTypes';
import { OPEN_CREDIT_DECISION_SLIDEOUT, CLOSE_CREDIT_DECISION_SLIDEOUT } from '../actionTypes/creditDecisionActionTypes';

export type DeskingGlobalReducer = Reducer<DeskingGlobalState>;

const initialState: DeskingGlobalState = {
    paymentDetailsAccordionExpanded: false,
    taxesAccordionExpanded: false,
    feesAccordionExpanded: false,
    lienholderAccordionExpanded: false,
    rollToPaymentSlideOutExpanded: false,
    isProgramsSlideOutOpen: false,
    isAccessoriesCatalogSlideOutOpen: false,
    isCreditDecisionSlideOutOpen: false,
    dealTypeOverrideReason: null
};

export const reducer: DeskingGlobalReducer = (state = initialState, action: AnyFSA) => {
    switch (action.type) {
        case PAYMENT_DETAILS_ACCORDION_TOGGLE: {
            return {
                ...state,
                paymentDetailsAccordionExpanded: !state.paymentDetailsAccordionExpanded
            };
        }
        case TAXES_ACCORDION_TOGGLE: {
            return {
                ...state,
                taxesAccordionExpanded: !state.taxesAccordionExpanded
            };
        }
        case FEES_ACCORDION_TOGGLE: {
            return {
                ...state,
                feesAccordionExpanded: !state.feesAccordionExpanded
            };
        }
        case LIENHOLDER_ACCORDION_TOGGLE: {
            return {
                ...state,
                lienholderAccordionExpanded: !state.lienholderAccordionExpanded
            };
        }
        case OPEN_PROGRAMS_SLIDEOUT: {
            return {
                ...state,
                isProgramsSlideOutOpen: true
            };
        }
        case CLOSE_PROGRAMS_SLIDEOUT: {
            return {
                ...state,
                isProgramsSlideOutOpen: false,
                programsSlideOutPreviousCalcEndpoint: null,
                programsSlideOutPreviousOfferType: null
            };
        }
        case SET_PROGRAMS_CALC_ENDPOINT_STASH: {
            return {
                ...state,
                programsSlideOutPreviousCalcEndpoint: action.payload?.previousCalcEndpoint ?? null,
                programsSlideOutPreviousOfferType: action.payload?.previousOfferType ?? null
            };
        }
        case OPEN_ACCESSORIES_CATALOG_SLIDEOUT: {
            return {
                ...state,
                isAccessoriesCatalogSlideOutOpen: true
            };
        }
        case CLOSE_ACCESSORIES_CATALOG_SLIDEOUT: {
            return {
                ...state,
                isAccessoriesCatalogSlideOutOpen: false
            };
        }
        case OPEN_CREDIT_DECISION_SLIDEOUT: {
            return {
                ...state,
                isCreditDecisionSlideOutOpen: true
            };
        }
        case CLOSE_CREDIT_DECISION_SLIDEOUT: {
            return {
                ...state,
                isCreditDecisionSlideOutOpen: false
            };
        }
        case DEAL_TYPE_OVERRIDDEN: {
            return {
                ...state,
                dealTypeOverrideReason: action.payload
            };
        }
        case DISMISS_DEAL_TYPE_OVERRIDE: {
            return {
                ...state,
                dealTypeOverrideReason: null
            };
        }
        default:
            return state;
    }
};
